import { render, staticRenderFns } from "./MypageButton.vue?vue&type=template&id=a7f130c2&scoped=true&"
import script from "./MypageButton.vue?vue&type=script&lang=js&"
export * from "./MypageButton.vue?vue&type=script&lang=js&"
import style0 from "./MypageButton.vue?vue&type=style&index=0&id=a7f130c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f130c2",
  null
  
)

export default component.exports